import React from 'react';
import { WbMarkdownHtml } from '../../../utils/common';
import RectBoxPercentage from '../../../components/rectbox';

const GoalRow = ({item, id, toggleChkBox, selectedItems=[]}) => {
    const type = id;
    return (
      <div key={`${type}_${item.id}`} className="rectbox-row ">
        <div className="rectbox-col">
          <div className="chkbox wbcheckboxcomp" data-testid="chkbox wbcheckboxcomp">
            <span style={{cursor:'pointer'}}>
                <div className={selectedItems.includes(item.id) ? "icon icon-outline-check_box-18px" : "icon icon-outline-check_box_outline_blank-18px"} value={item.id} onClick={e => toggleChkBox(e, item)} id={`item-chk-${item.id}`}/>
            </span>
            <label className="css-label modalParaText" htmlFor={`item-chk-${item.id}`} />
          </div>
        </div>
        <div className="rectbox-col">
          <RectBoxPercentage count={`${item.progress}%`} style={{ color: item.progress_color, borderRadius: '4px'}} />
        </div>
        <div className={"rectbox-col rectbox-col-goal rectbox-col-line"+ (type == 'objective' ? " okrBoxMargin" : "")}>
          <div className="rectbox-title"  data-testid="rectbox-title">
            <span>
              {item.goal}
            </span>
          </div>
          <div className="rectbox-subtitle">
            <div dangerouslySetInnerHTML={WbMarkdownHtml(item.teamName ? `${item.teamName} <span class="dotClass"></span> ${item.ownerName} <span class="dotClass"></span> ${item.achieveDate}` : item.ownerName)} />
          </div>
        </div>
      </div>
    );
    
};

export default GoalRow;